import styled from 'styled-components';
import { Box } from '@mui/material';
export const StyledBulkActionsRowContainer = styled(Box) `
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  justify-content: space-between;
`;
